import { ISingleResponse, ISubscriptionResponse } from '@bg-shared/business/Betting/interfaces';

type ILegacyItem = { data: ISingleResponse | ISubscriptionResponse };
type ILegacySingleItem = { data: ISingleResponse };
type ILegacySubscriptionItem = { data: ISubscriptionResponse };
type IMixedItem = ILegacyItem | ISingleResponse | ISubscriptionResponse;

export const multiTypeCheck = {
    isLegacySingle: (item: IMixedItem): item is ILegacySingleItem =>
        !!(item as ILegacySingleItem).data?.bet,

    isLegacySubscription: (item: IMixedItem): item is ILegacySubscriptionItem =>
        !!(item as ILegacySubscriptionItem).data?.subscription,

    isSingle: (bet: IMixedItem): bet is ISingleResponse => !!(bet as ISingleResponse).bet,

    isSubscription: (bet: IMixedItem): bet is ISubscriptionResponse =>
        !!(bet as ISubscriptionResponse).subscription,
};
